<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Devis",
          icon: "bi bi-file-earmark-text-fill",
          route: "quotations-index",
        },
        {
          label: "Nouveau devis",
          icon: "bi bi-file-earmark-plus-fill",
          route: "quotations-create",
        },
        {
          label: "Ajouter articles",
          icon: "bi bi-list-ul",
          route: "quotations-items-create",
        },
      ],
    };
  },
};
</script>
